import { Button, styled } from '@mui/material';

// ----------------------------------------------------------------------

export type SubmenuItemButtonProps = {
  title: string;
  onClick: () => void;
};

// ----------------------------------------------------------------------

export const StyledRoot = styled(Button)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  justifyContent: 'start',
  fontSize: 14,
  fontWeight: 400,
  color: theme.palette.text.primary,

  '&:hover': {
    backgroundColor: '#E6EBF0',
  },
  '&:not(:hover)': {
    backgroundColor: 'transparent',
  },
})) as typeof Button;

// ----------------------------------------------------------------------

export const SubmenuButtonItem = (props: SubmenuItemButtonProps) => {
  const { title, onClick } = props;

  return <StyledRoot onClick={onClick}>{title}</StyledRoot>;
};
